import * as React from "react";
import { forwardRef } from "react";
const SvgTick = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 11, viewBox: "0 0 14 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M4.87887 10.6859L0.63623 6.44327L2.5229 4.5566L4.87887 6.91925L11.4775 0.313965L13.3642 2.20063L4.87887 10.6859Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgTick);
export { ForwardRef as ReactComponent };
